export const invoiceConfig = {
    invoicePattern: '{invoice}'
}